import { NECTAR_ACCESS_TOKEN_KEY, NECTAR_AUTH_ADDRESS_KEY } from "config/localStorage";

export const AUTH_TOKEN_CHANGED_EVENT = "nectar:auth-token-changed";

function notifyAuthTokenChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(AUTH_TOKEN_CHANGED_EVENT));
  }
}

export function saveAccessToken(token: string, address?: string) {
  localStorage.setItem(NECTAR_ACCESS_TOKEN_KEY, token);
  if (address) {
    localStorage.setItem(NECTAR_AUTH_ADDRESS_KEY, address.toLowerCase());
  }
  notifyAuthTokenChanged();
}

export function getAccessToken(): string | null {
  return localStorage.getItem(NECTAR_ACCESS_TOKEN_KEY);
}

export function getAuthAddress(): string | null {
  return localStorage.getItem(NECTAR_AUTH_ADDRESS_KEY);
}

export function clearAccessToken() {
  const hadToken = Boolean(localStorage.getItem(NECTAR_ACCESS_TOKEN_KEY));
  localStorage.removeItem(NECTAR_ACCESS_TOKEN_KEY);
  localStorage.removeItem(NECTAR_AUTH_ADDRESS_KEY);
  if (hadToken) {
    notifyAuthTokenChanged();
  }
}

export function isLoggedIn(): boolean {
  return Boolean(getAccessToken());
}

export function authHeaders(extra?: HeadersInit): HeadersInit {
  const token = getAccessToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

/** True when a stored token exists and is bound to the given wallet address. */
export function isTokenBoundToAddress(address: string | undefined | null): boolean {
  if (!address || !getAccessToken()) {
    return false;
  }
  const bound = getAuthAddress();
  if (!bound) {
    return true;
  }
  return bound === address.toLowerCase();
}
